export default {
    setFeedList(state, payload) {
        state.feedList = payload;
    },
    setSentiment(state, payload) {
        const feed = state.feedList.find((x) => x.id == payload.feedId);

        if (feed) feed.sentimentId = payload.sentimentId;
    },
    putFeedFinalizeStatus(state, payload) {
        for (const selectedFeedId of payload.feedsToBeFinalize) {
            const feed = state.feedList.find((x) => x.id == selectedFeedId);

            if (feed) {
                const indexToBeRemoved = state.feedList.indexOf(feed);

                state.feedList.splice(indexToBeRemoved, 1);
            }
        }

        for (const newlyAssigned of payload.newAssignedFeeds) {
            state.feedList.push(newlyAssigned);
        }
    },
    putFeedMarkedToBeHashedStatus(state, payload) {
        state.feedsToBeMasked.length = 0;
        state.feedsAlreadyMarkedForMasking.length = 0;

        for (const selectedFeedId of payload.feedsToBeMasked) {
            const feed = state.feedList.find(x => x.id == selectedFeedId);

            if (feed) {
                const indexToBeUpdated = state.feedList.indexOf(feed);

                state.feedList[indexToBeUpdated].isContentMarkedToBeMasked = true;
                state.feedsToBeMasked.push(selectedFeedId);
            }
        }

        for (const alreadySelectedFeedId of payload.feedsAlreadyMarked) {
            const feed = state.feedList.find(x => x.id == alreadySelectedFeedId);

            if (feed) state.feedsAlreadyMarkedForMasking.push(alreadySelectedFeedId);
        }
    },
    putFeedUnmaskStatus(state, payload) {
        state.feedsCannotBeUnmasked.length = 0;

        for (const selectedFeed of payload.unmaskedFeedList) {
            const feed = state.feedList.find(x => x.id == selectedFeed.item1);

            if (feed) {
                const indexToBeUpdated = state.feedList.indexOf(feed);

                state.feedList[indexToBeUpdated].isContentMasked = false;
                state.feedList[indexToBeUpdated].bodyText = selectedFeed.item2;
                state.feedList[indexToBeUpdated].isContentMarkedToBeMasked = false;
            }
        }

        for (const unableToBeUnmaskedId of payload.unableToUnmaskList) {
            const feed = state.feedList.find(x => x.id == unableToBeUnmaskedId);

            if (feed) state.feedsCannotBeUnmasked.push(unableToBeUnmaskedId);
        }
    },
    putFeedRelativeStatus(state, payload) {
        for (const selectedFeedId of payload.feedsToBeRelative) {
            const feed = state.feedList.find((x) => x.id == selectedFeedId);

            if (feed) {
                const indexToBeUpdated = state.feedList.indexOf(feed);

                state.feedList[indexToBeUpdated].irrelative = !payload.isrelative;
            }
        }
    },
    putFeedSpamStatus(state, payload) {
        for (const feedId of payload.feedsToBeSpam) {
            const feed = state.feedList.find((x) => x.id == feedId);

            if (feed) {
                const indexToBeUpdated = state.feedList.indexOf(feed);

                state.feedList[indexToBeUpdated].isspam = payload.isSpam;
            }
        }
    },
    setModerationReasons(state, payload) {
        state.moderationReason = payload;
    },
    setWorkspaceTags(state, payload) {
        state.workspaceTags = payload;
    },
    setFeederConfirmation(state, payload) {
        for (const feedId of payload.feedIds) {
            const feed = state.feedList.find(x => x.id == feedId);

            if (feed) {
                const indexToBeDeleted = state.feedList.indexOf(feed);

                if (payload.origin == 1) {
                    state.feedList[indexToBeDeleted].confirmationOrigin = "Teyit Alındı: Hat Sahibi";
                } else if (payload.origin == 2) {
                    state.feedList[indexToBeDeleted].confirmationOrigin = "Teyit Alındı: Kullanıcı";
                }
            }
        }
    },
    deleteFeed(state, payload) {
        for (const feedId of payload.feedIds) {
            const feed = state.feedList.find(x => x.id == feedId);

            if (feed) {
                const indexToBeDeleted = state.feedList.indexOf(feed);

                state.feedList[indexToBeDeleted].isDeleted = true;
            }
        }
    },
    hideFeed(state, payload) {
        for (const selectedFeedId of payload.feedIds) {
            const feed = state.feedList.find((x) => x.id == selectedFeedId);

            if (feed) {
                const indexToBeUpdated = state.feedList.indexOf(feed);

                state.feedList[indexToBeUpdated].isHidden = true;
            }
        }
    },
    showFeed(state, payload) {
        for (const selectedFeedId of payload.feedIds) {
            const feed = state.feedList.find((x) => x.id == selectedFeedId);

            if (feed) {
                const indexToBeUpdated = state.feedList.indexOf(feed);

                state.feedList[indexToBeUpdated].isHidden = false;
            }
        }
    },
    likeFeed(state, payload) {
        for (const selectedFeedId of payload.feedIds) {
            const feed = state.feedList.find((x) => x.id == selectedFeedId);

            if (feed) {
                const indexToBeUpdated = state.feedList.indexOf(feed);

                state.feedList[indexToBeUpdated].isLiked = true;
            }
        }
    },
    dislikeFeed(state, payload) {
        for (const selectedFeedId of payload.feedIds) {
            const feed = state.feedList.find((x) => x.id == selectedFeedId);

            if (feed) {
                const indexToBeUpdated = state.feedList.indexOf(feed);

                state.feedList[indexToBeUpdated].isLiked = false;
            }
        }
    },
    setCommentHistory(state, payload) {
        state.commentHistory = payload;
    },
    setRegisteredSocialAccounts(state, payload) {
        state.registeredSocialAccounts = payload;
    },
    setReplyDrafts(state, payload) {
        state.repyDrafts = payload;
    },
    setAttachments(state, payload) {
        state.attachments = payload;
    },
    setFeederHistory(state, payload) {
        if (state.feederHistory && state.feederHistory.length > 0) {
            payload.forEach((history) => {
                state.feederHistory.push(history);
            });
        } else {
            state.feederHistory = payload
        }
    },
    setDeletedHistory(state, payload) {
        state.feederHistory = state.feederHistory.map(item => {
            if (item.answers.length > 0) item.answers = item.answers.filter(answer => answer.id !== payload.answerId);

            return item;
        });
    },
    setEmptyFeederHistory(state) {
        state.feederHistory = [];
    },
    setFoxTaskTitles(state, payload) {
        state.foxTaskTitles = payload;
    },
    setFoxReplyTypes(state, payload) {
        state.foxReplytypes = payload;
    },
    setFoxPreviousReplies(state, payload) {
        state.foxPreviousReply = "";

        for (const data of payload) {
            state.foxPreviousReply += `${data.answer} `;
        }
    },
    setFoxCategories(state, payload) {
        state.foxCategories = payload;
    },
    setFoxTaskThanked(state, payload) {
        state.foxFeedbacks = payload;
    },
    setFoxChannels(state, payload) {
        state.foxChannels = payload;
    },
    setFoxComments(state, payload) {
        state.foxComments = payload;
    },
    setFoxPages(state, payload) {
        state.foxPages = payload;
    },
    setFoxRelatedFeeds(state, payload) {
        state.foxRelatedFeeds = payload;
    },
    setFoxTaskItems(state, payload) {
        state.foxTaskTitles = payload.subjectOptions;
        state.foxReplytypes = payload.replyTypeOptions;
        state.foxPreviousReply = payload.previousRepliesVal;
        state.foxCategories = payload.categoryOptions;
        state.foxFeedbacks = payload.feedbackOptions;
        state.foxChannels = payload.channelOptions;
        state.foxComments = payload.commentOptions;
        state.foxPages = payload.pageOptions;
        state.foxRelatedFeeds = payload.relatedFeeds;
        state.foxGsmTypeOptions = payload.gsmTypeOptions;
    },
    updateFoxData(state, payload) {
        const subjectCode = state.foxTaskTitles.find(x => x.id == payload.subject).code;
        payload.subject = subjectCode;

        const replyTypeCode = state.foxReplytypes.find(x => x.id == payload.answer).code;
        payload.answer = replyTypeCode;

        const categoryCode = state.foxCategories.find(x => x.id == payload.classes).code;
        payload.classes = categoryCode;

        const feedbackCode = state.foxFeedbacks.find(x => x.id == payload.thanks).code;
        payload.thanks = feedbackCode;

        const channelCode = state.foxChannels.find(x => x.id == payload.channel).code;
        payload.channel = channelCode;

        const commentCode = state.foxComments.find(x => x.id == payload.comment).code;
        payload.comment = commentCode;

        const pageCode = state.foxPages.find(x => x.id == payload.page).code;
        payload.comment = pageCode;

        state.foxData = payload;
    },
    setFoxHistory(state, payload) {
        state.foxHistory = payload;
    },
    setEmojis(state, payload) {
        state.emojiList = payload;
    },
    setEmojisIsEnabled(state, payload) {
        state.emojisIsEnabled = payload;
    },
    setMisspells(state, payload) {
        state.misspellList = payload;
    },
    setFeedAnswers(state, payload) {
        state.feedAnswers = payload;
    },
    putSuggestionList(state, payload) {
        const correctedMisspel = state.misspellList.find(x => x.misspellMatch == payload.replacedItem);

        if (correctedMisspel) {
            const indexOfCorrectedMisspel = state.misspellList.indexOf(correctedMisspel)
        
            state.misspellList.splice(indexOfCorrectedMisspel, 1);
        }
    },
    setCheckAnswerRules(state, payload) {
        state.checkAnswerRules = payload;
    },
    setAnswerAudit(state, payload) {
        state.answerAudit = payload;
    },
    setAnswerAuditEnabled(state, payload) {
        state.answerAuditEnabled = payload;
    },
    setCepDefinition(state, payload) {
        state.cepDefinition = payload.definition;
        state.cepDefinitionWorkspaceId = payload.workspaceId;
    },
    setFeedAnswer(state, payload) {
        state.feedAnswer = payload;
    },
    setDynamicsCountry(state, payload) {
        state.dynamicsCountries = payload;
    },
    setDynamicsRelatedFeeds(state, payload) {
        state.dynamicsRelatedFeeds = payload;
    },
    setDynamicsMainFeed(state, payload) {
        state.dynamicsMainFeed = payload;
    },
    setDynamicsIdError(state, payload) {
        state.dynamicsIdError = payload;
    },
    setCheckAnswerCount(state, payload) {
        state.checkAnswerCount = payload;
    },
    setCheckAnswerCountCopyTable(state, payload) {
        state.checkAnswerCountCopyTable = payload;
    },
    deleteMisspellList(state) {
        state.misspellList.length = 0;
    },
    setTotalHistoryCount(state, payload) {
        state.totalHistoryCount = payload;
    },
    setReplySuggestions(state, payload) {
        state.replySuggestions = payload;
    },
    setSelectedSuggestion(state, payload) {
        state.selectedReplyText = payload;
    },
    setFeedNotes(state, payload) {
        state.feedNotes = payload;
    },
    deleteFeedNote(state, payload) {
        const noteToBeDeleted = state.feedNotes.find(x => x.id == payload.id);
        const indexToBeDeleted = state.feedNotes.indexOf(noteToBeDeleted);

        state.feedNotes.splice(indexToBeDeleted, 1);
    }
}